import {IIframeService, INavigateReturnsProps, IresizeIframeProps, LARAVEL_TYPE} from "./iframe-service";

export default class IframeServiceStub implements IIframeService {

    constructor(private _apiUrl?: string) {

    }
    
    getApiUrl(): Promise<string|undefined> {
        return Promise.resolve(this._apiUrl);
    }

    getRmsApiUrl(): Promise<string|undefined> {
        return Promise.resolve(undefined);
    }

    getDashboardSettings(): Promise<string> {
        return Promise.resolve('');
    }

    refreshParentFrame(): void { }

    navigateReturns(props: INavigateReturnsProps): Promise<boolean> {
        return new Promise((resolve) => {
            resolve(true);
        });
    }
    
    redirectParentFrame(url: string): Promise<boolean> {
        return new Promise((resolve) => {
            resolve(true);
            window.location.href = url;
        });
    }

    resizeIframe(props: IresizeIframeProps): Promise<boolean> {
        return new Promise((resolve) => {
            resolve(true);
        });
    }

    openParentIframeChat(): Promise<boolean> {
        return new Promise((resolve) => {
            resolve(true);
        });
    }

    changeParentPath(path: string): Promise<void> {
        return Promise.resolve();
    }

    closeOnboardingWizardModal(): Promise<boolean> {
        return new Promise((resolve) => {
            resolve(true);
        });
    }

    updateLeftMenuReturnGuard(isEnabled: boolean): Promise<boolean> {
        return new Promise((resolve) => {
            resolve(true);
        });
    }

    subscribeToParentEvent(eventName: keyof typeof LARAVEL_TYPE, listener: (message?: any) => void): () => void {
        return () => {};
    };

    getInAppRedirectUrl(path: string, origin: string): string {
        return '';
    }

    logout(): Promise<void> {
        return Promise.resolve();
    }
}
